import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { ListItem, ListItemText, ListItemIcon } from "@material-ui/core";
import { NavLink, matchPath, withRouter } from "react-router-dom";

const MenuItem = ({ item, location, classes }) => {
  const active = matchPath(location.pathname, { path: [item.path] }) != null;
  return (
    <NavLink to={item.path} exact className={classes.link} activeClassName={classes.activeItem}>
      <ListItem button key={item.title} className={clsx(classes.item, classes.itemCategory, active && classes.activeItem)}>
        <ListItemIcon>{item.icon}</ListItemIcon>
        <ListItemText
          classes={{
            primary: classes.itemPrimary
          }}
          primary={item.title}
        />
      </ListItem>
    </NavLink>
  );
};

MenuItem.propTypes = {
  classes: PropTypes.shape({ link: PropTypes.string.isRequired }).isRequired,
  item: PropTypes.shape({ title: PropTypes.string.isRequired }).isRequired,
  location: PropTypes.shape({ pathname: PropTypes.string.isRequired }).isRequired
};

export default withRouter(React.memo(MenuItem));
